import { supabase } from '@/lib/supabase/client';

/**
 * Service per le operazioni di attivazione dei dealer tramite RPC
 * Utilizza funzioni RPC con SECURITY DEFINER per evitare problemi di autenticazione
 */
export const activationRpcService = {
  /**
   * Verifica se esiste una richiesta di attivazione in corso per un dealer
   */
  checkPendingRequest: async (dealerId: string) => {
    console.log("[ActivationRpcService] Checking pending activation request for dealer:", dealerId);
    
    try {
      const { data, error } = await supabase
        .from('dealer_activation_requests')
        .select('id, status')
        .eq('dealer_id', dealerId)
        .eq('status', 'PENDING')
        .limit(1);
      
      if (error) {
        console.error("[ActivationRpcService] Error checking pending request:", error);
        return false;
      }
      
      const hasPendingRequest = data && data.length > 0;
      console.log("[ActivationRpcService] Dealer has pending request:", hasPendingRequest);
      return hasPendingRequest;
    } catch (error) {
      console.error("[ActivationRpcService] Error in checkPendingRequest:", error);
      return false;
    }
  },
  /**
   * Richiede l'attivazione di un dealer
   * Utilizza una funzione RPC per evitare problemi di autenticazione
   */
  requestActivation: async (dealerId: string, userId: string) => {
    console.log("[ActivationRpcService] Requesting activation for dealer:", dealerId);
    
    try {
      const { data, error } = await supabase
        .rpc('request_dealer_activation', {
          dealer_id_param: dealerId,
          user_id_param: userId
        });
      
      if (error) {
        console.error("[ActivationRpcService] Error requesting activation:", error);
        throw error;
      }
      
      console.log("[ActivationRpcService] Activation request submitted successfully:", data);
      return data;
    } catch (error) {
      console.error("[ActivationRpcService] Error in requestActivation:", error);
      throw error;
    }
  },
  
  /**
   * Recupera le richieste di attivazione in sospeso con i dettagli del dealer
   * Utilizza una funzione RPC per evitare problemi di autenticazione
   */
  fetchPendingRequests: async () => {
    console.log("[ActivationRpcService] Fetching pending activation requests");
    
    try {
      const { data, error } = await supabase
        .rpc('get_pending_activation_requests');
      
      if (error) {
        console.error("[ActivationRpcService] Error fetching requests:", error);
        throw error;
      }
      
      console.log("[ActivationRpcService] Successfully fetched requests:", data);
      return data || [];
    } catch (error) {
      console.error("[ActivationRpcService] Error in fetchPendingRequests:", error);
      // Return empty array on error instead of throwing
      return [];
    }
  },
  
  /**
   * Rifiuta una richiesta di attivazione dealer
   */
  rejectRequest: async (requestId: string, adminNotes: string) => {
    console.log("[ActivationRpcService] Rejecting request:", requestId);
    
    try {
      const { data, error } = await supabase
        .rpc('reject_activation_request', {
          admin_notes_text: adminNotes,
          request_id: requestId
        });
      
      if (error) {
        console.error("[ActivationRpcService] Error rejecting request:", error);
        throw error;
      }
      
      console.log("[ActivationRpcService] Request rejected successfully:", data);
      return true;
    } catch (error) {
      console.error("[ActivationRpcService] Error in rejectRequest:", error);
      throw error;
    }
  },
  
  /**
   * Approva una richiesta di attivazione dealer
   */
  approveRequest: async (requestId: string, dealerId: string, userId: string) => {
    console.log("[ActivationRpcService] Approving request:", requestId);
    
    try {
      const { data, error } = await supabase
        .rpc('approve_activation_request', {
          request_id: requestId,
          dealer_id_param: dealerId,
          user_id_param: userId
        });
      
      if (error) {
        console.error("[ActivationRpcService] Error approving request:", error);
        throw error;
      }
      
      console.log("[ActivationRpcService] Request approved successfully:", data);
      return true;
    } catch (error) {
      console.error("[ActivationRpcService] Error in approveRequest:", error);
      throw error;
    }
  }
};
